//scopes

import { Apps } from "@mui/icons-material";
import { RxTableFilters } from "../../api-client";

const scopes = {
  rx: "rx",
  rxIds: "rxIds", 
  rxList: "rxList", // For RxLightDto[] queries
  rxSeries: "rxSeries",
  therapyRxSeries: "therapyRxSeries",
  rxSeriesList: "rxSeriesList",
  rxLackingAppointments: "rxLackingAppointments",
  allRxsTable:"allRxsTable",
  rxDeletable: "rxDeletable",
  templateWidgetData: "templateWidgetData",
};

export const rxKeys = {
  rx: {
    scope: scopes.rx,
    all: () => [scopes.rx] as const,
    detail: (rxId: string) => 
      [scopes.rx, { rxId }] as const,
  },
  rxIds: {
    scope: scopes.rxIds,
    all: () => [scopes.rxIds] as const,
    detail: (patientId: number, activeOnly: boolean) => 
      [scopes.rxIds, { patientId, activeOnly }] as const,
  },
  rxList: {
    scope: scopes.rxList,
    all: () => [scopes.rxList] as const,
    forPatient: (patientId: number) => 
      [scopes.rxList, { patientId }] as const,
  },
  rxSeries: {
    scope: scopes.rxSeries,
    all: () => [scopes.rxSeries] as const,
    detail: (seriesId: string) => 
      [scopes.rxSeries, { seriesId }] as const,
  },
  rxSeriesList: {
    scope: scopes.rxSeriesList,
    all: () => [scopes.rxSeriesList] as const,
    forPatient: (patientId: number) =>
      [scopes.rxSeriesList, { patientId }] as const,
  },
  therapyRxSeries: {
    scope: scopes.therapyRxSeries,
    all: () => [scopes.therapyRxSeries] as const,
    forPatient: (patientId: number) => 
      [scopes.therapyRxSeries, { patientId }] as const,
  },
  rxLackingAppointments: {
    scope: scopes.rxLackingAppointments,
    all: () => [scopes.rxLackingAppointments] as const,
    forPatient: (patientId: number) =>
      [scopes.rxLackingAppointments, { patientId }] as const,
  },
  allRxsTable:{
     scope: scopes.allRxsTable,
     all: () => [scopes.allRxsTable] as const,
     filtered: (filters: RxTableFilters) => [scopes.allRxsTable, filters] as const,

    },
  rxDeletable: {
    scope: scopes.rxDeletable,
    all: () => [scopes.rxDeletable] as const,
    detail: (rxId: string) => [scopes.rxDeletable, { rxId }] as const,
  },
  templateWidgetData: {
    scope: scopes.templateWidgetData,
    all: () => [scopes.templateWidgetData] as const,
    forPatient: (patientId: number) =>
      [scopes.templateWidgetData, { patientId }] as const,
  },
};
